import CLogo1 from '../../assets/img/client-50/client-logo1.png';
import CLogo2 from '../../assets/img/client-50/client-logo2.png';
import CLogo3 from '../../assets/img/client-50/client-logo3.png';
import CLogo4 from '../../assets/img/client-50/client-logo4-1.png';
import CLogo5 from '../../assets/img/client-50/client-logo5.png';
import CLogo6 from '../../assets/img/client-50/client-logo6-1.png';
import CLogo7 from '../../assets/img/client-50/client-logo7.png';
import CLogo8 from '../../assets/img/client-50/client-logo8.png';
import CLogo9 from '../../assets/img/client-50/client-logo9.png';
import CLogo10 from '../../assets/img/client-50/client-logo10-1.png';
import CLogo11 from '../../assets/img/client-50/client-logo11.png';
import CLogo12 from '../../assets/img/client-50/client-logo12.png';
import CLogo13 from '../../assets/img/client-50/client-logo13-1.png';
import CLogo14 from '../../assets/img/client-50/client-logo14-1.png';
import CLogo15 from '../../assets/img/client-50/client-logo15.png';
import CLogo16 from '../../assets/img/client-50/client-logo16.png';
import CLogo17 from '../../assets/img/client-50/client-logo17.png';
import CLogo18 from '../../assets/img/client-50/client-logo18-1.png';
import CLogo19 from '../../assets/img/client-50/client-logo19.png';
import CLogo20 from '../../assets/img/client-50/client-logo20.png';
import CLogo21 from '../../assets/img/client-50/client-logo21.png';
import CLogo22 from '../../assets/img/client-50/client-logo22-1.png';
import CLogo23 from '../../assets/img/client-50/client-logo23.png';
import CLogo24 from '../../assets/img/client-50/client-logo24-1.png';
import CLogo25 from '../../assets/img/client-50/client-logo25.png';
import CLogo26 from '../../assets/img/client-50/client-logo26.png';
import CLogo27 from '../../assets/img/client-50/client-logo27.png';
import CLogo28 from '../../assets/img/client-50/client-logo28-1.png';
import CLogo29 from '../../assets/img/client-50/client-logo29.png';
import CLogo30 from '../../assets/img/client-50/client-logo30-1.png';
import CLogo31 from '../../assets/img/client-50/client-logo31.png';
import CLogo32 from '../../assets/img/client-50/client-logo32.png';
import CLogo33 from '../../assets/img/client-50/client-logo33.png';
import CLogo34 from '../../assets/img/client-50/client-logo34.png';
import CLogo35 from '../../assets/img/client-50/client-logo35.png';
import CLogo36 from '../../assets/img/client-50/client-logo36.png';
import CLogo37 from '../../assets/img/client-50/client-logo37.png';
import CLogo38 from '../../assets/img/client-50/client-logo38.png';
import CLogo39 from '../../assets/img/client-50/client-logo39-1.png';
import CLogo40 from '../../assets/img/client-50/client-logo40.png';
import CLogo41 from '../../assets/img/client-50/client-logo41.png';
import CLogo42 from '../../assets/img/client-50/client-logo42.png';
import CLogo43 from '../../assets/img/client-50/client-logo43-1.png';
import CLogo44 from '../../assets/img/client-50/client-logo44.png';
import CLogo45 from '../../assets/img/client-50/client-logo45.png';
import CLogo46 from '../../assets/img/client-50/client-logo46.png';
import CLogo47 from '../../assets/img/client-50/client-logo47.png';
import CLogo48 from '../../assets/img/client-50/client-logo48.png';
import CLogo49 from '../../assets/img/client-50/client-logo49.png';
import CLogo50 from '../../assets/img/client-50/client-logo50.png';
import CLogo51 from '../../assets/img/client-50/client-logo51.png';
import CLogo52 from '../../assets/img/client-50/client-logo52.png';
import CLogo53 from '../../assets/img/client-50/client-logo53.png';
import CLogo54 from '../../assets/img/client-50/client-logo54.png';
import CLogo55 from '../../assets/img/client-50/client-logo55.png';
import CLogo56 from '../../assets/img/client-50/client-logo56.png';
import CLogo57 from '../../assets/img/client-50/client-logo57.png';
import CLogo58 from '../../assets/img/client-50/client-logo58.png';
import CLogo59 from '../../assets/img/client-50/client-logo59-1.png';
import CLogo60 from '../../assets/img/client-50/client-logo60-1.png';
import CLogo61 from '../../assets/img/client-50/client-logo61-1.png';
import CLogo62 from '../../assets/img/client-50/client-logo62-1.png';
import CLogo63 from '../../assets/img/client-50/client-logo63-1.png';
import CLogo64 from '../../assets/img/client-50/client-logo64-1.png';
import CLogo65 from '../../assets/img/client-50/client-logo65.png';
import CLogo66 from '../../assets/img/client-50/client-logo66.png';
import CLogo67 from '../../assets/img/client-50/client-logo67-1.png';
import CLogo68 from '../../assets/img/client-50/client-logo68-1.png';
import CLogo69 from '../../assets/img/client-50/client-logo69.png';
import CLogo70 from '../../assets/img/client-50/client-logo70-1.png';
import CLogo71 from '../../assets/img/client-50/client-logo71-1.png';
import CLogo72 from '../../assets/img/client-50/client-logo72-1.jpg';
import CLogo73 from '../../assets/img/client-50/client-logo73-1.png';
import CLogo74 from '../../assets/img/client-50/client-logo74.png';
import CLogo75 from '../../assets/img/client-50/client-logo75-1.png';
import CLogo76 from '../../assets/img/client-50/client-logo76-1.png';

export const ClientLogo50 = [
    {
        img: CLogo1,
        alt: 'CIEL HR',
    },
    {
        img: CLogo2,
        alt: 'Sun Technologies',
    },
    {
        img: CLogo3,
        alt: 'BDS Services',
    },
    {
        img: CLogo4,
        alt: 'Delaplex',
    },
    {
        img: CLogo5,
        alt: 'Cognisive',
    },
    {
        img: CLogo6,
        alt: 'Palni',
    },
    {
        img: CLogo7,
        alt: 'Quarks',
    },
    {
        img: CLogo8,
        alt: 'Workfreaks',
    },
    {
        img: CLogo9,
        alt: 'Hammoq',
    },
    {
        img: CLogo10,
        alt: 'Quantela',
    },
    {
        img: CLogo11,
        alt: 'Safexpay',
    },
    {
        img: CLogo12,
        alt: 'Brihaspathi',
    },
    {
        img: CLogo13,
        alt: 'Enlume',
    },
    {
        img: CLogo14,
        alt: 'Gowra Bits & Bytes Private Limited',
    },
    {
        img: CLogo15,
        alt: 'Inventum',
    },
    {
        img: CLogo16,
        alt: 'Triveni',
    },
    {
        img: CLogo17,
        alt: 'Trustrace',
    },
    {
        img: CLogo18,
        alt: 'Simulanis Solutions',
    },
    {
        img: CLogo19,
        alt: 'GyanMatrix Technologies',
    },
    {
        img: CLogo20,
        alt: 'Cylsys',
    },
    {
        img: CLogo21,
        alt: 'Agami Technologies',
    },
    {
        img: CLogo22,
        alt: 'DEVtrust DevTech Enterprises',
    },
    {
        img: CLogo23,
        alt: 'DIT',
    },
    {
        img: CLogo24,
        alt: 'Trivialworks Solutions',
    },
    {
        img: CLogo25,
        alt: 'Splash India',
    },
    {
        img: CLogo26,
        alt: 'ReapMind Innovations',
    },
    {
        img: CLogo27,
        alt: 'DoomShell',
    },
    // {
    //     img : CLogo28,
    //     alt : 'Brain Wave Consulting'
    // },
    {
        img: CLogo29,
        alt: 'AWAN INFOTECH',
    },
    {
        img: CLogo30,
        alt: 'Synergetics',
    },
    // {
    //     img : CLogo31,
    //     alt : 'Info people'
    // },
    {
        img: CLogo32,
        alt: 'PVR Developers',
    },
    {
        img: CLogo33,
        alt: 'Pyrite Technologies',
    },
    {
        img: CLogo34,
        alt: 'Necurity Solutions',
    },
    {
        img: CLogo35,
        alt: 'Escale Solutions',
    },
    {
        img: CLogo36,
        alt: 'IndieFolio',
    },
    {
        img: CLogo37,
        alt: 'Dikonia',
    },
    {
        img: CLogo38,
        alt: 'Questa Software Systems',
    },
    {
        img: CLogo39,
        alt: 'INFOTRONICX',
    },
    {
        img: CLogo40,
        alt: 'Adrixus',
    },
    {
        img: CLogo41,
        alt: 'e Age Technologies',
    },
    {
        img: CLogo42,
        alt: 'Enterprise Mobility Xperts',
    },
    {
        img: CLogo43,
        alt: 'Jobminar Consultants Private Limited',
    },
    {
        img: CLogo44,
        alt: 'AVGI SOLUTIONS PVT LTD',
    },
    {
        img: CLogo45,
        alt: 'HV InfoTech',
    },
    {
        img: CLogo46,
        alt: 'Wise Idiot Intellect Pvt Ltd',
    },
    {
        img: CLogo47,
        alt: 'Radiant Web Technology',
    },
    {
        img: CLogo48,
        alt: 'Triveous',
    },
    {
        img: CLogo49,
        alt: 'Definitics Software Solutions',
    },
    {
        img: CLogo50,
        alt: 'Qurious Click Digital Agency',
    },
    {
        img: CLogo51,
        alt: 'CitrusLeaf Technologies',
    },
    {
        img: CLogo52,
        alt: 'Ailogix Software Solutions',
    },
    // {
    //     img : CLogo53,
    //     alt : 'Skill Dunia'
    // },
    {
        img: CLogo54,
        alt: 'CaryTek India',
    },
    {
        img: CLogo55,
        alt: 'HR4U CONSULTING',
    },
    {
        img: CLogo56,
        alt: 'Tango IT Solutions Pvt Ltd',
    },
    // {
    //     img : CLogo57,
    //     alt : 'Tech Vidyaa'
    // },
    {
        img: CLogo58,
        alt: 'Wallero Technologies',
    },
    {
        img: CLogo59,
        alt: 'Nimap Infotech',
    },
    {
        img: CLogo60,
        alt: 'OPSTREE',
    },
    {
        img: CLogo61,
        alt: 'Umbrella infocare',
    },
    {
        img: CLogo62,
        alt: 'Verinite',
    },
    {
        img: CLogo63,
        alt: 'MasterCom Technology Services',
    },
    {
        img: CLogo64,
        alt: 'Procol',
    },
    {
        img: CLogo65,
        alt: 'Naico Information Technology Services',
    },
    {
        img: CLogo66,
        alt: 'Ethane Technologies',
    },
    {
        img: CLogo67,
        alt: 'MyAnatomy Integration Pvt Ltd',
    },
    {
        img: CLogo68,
        alt: 'Skill Recruit',
    },
    {
        img: CLogo69,
        alt: 'Smart Docs',
    },
    {
        img: CLogo70,
        alt: 'Prototech Solutions',
    },
    {
        img: CLogo71,
        alt: 'Autus',
    },
    {
        img: CLogo72,
        alt: 'Cosette Network',
    },
    // {
    //     img : CLogo73,
    //     alt : 'S Gate tech solutions'
    // },
    {
        img: CLogo74,
        alt: 'Acviss Technologies',
    },
    {
        img: CLogo75,
        alt: 'Camfy Vision',
    },
    {
        img: CLogo76,
        alt: 'Yeldam',
    },
];
